export default {"src":"/_next/static/media/play-icon.146e7eb6.svg","height":84,"width":84,"blurWidth":0,"blurHeight":0};